import React, { Component } from "react";

import { withTimerangeIntelligence } from "../../../shared/containers/containerTimerangeIntelligence";
import { withPositions } from "../../../shared/containers/containerPositions";
import { withMapPositions } from "../../../shared/containers/containerMapPositions";

import { withIntelligenceTimeRangePlayer } from "../../../shared/containers/containerIntelligenceTimeRangePlayer";
import { withTimeRangeIntelligenceType } from "../../../shared/containers/containerTimeRangeIntelligenceType";
import { withReportsList } from "../../../shared/containers/containerReportsList";

import { withIntelligenceControl } from "../../../shared/containers/containerIntelligenceControl";

import Notification from "./../../../shared/items/static/notification";
import Preloader from "./../../../shared/items/static/preloader";

import getRouteTableData from "../../../shared/services/routeTable.service";
import getDates from "../../../shared/services/date.service";
import messages from "./../../../shared/static.messages";
import { states } from "../../../reducers/queriesStates";
import { intelligenceTypes } from "./static.timeRangeIntelligenceTypes";
import styles from "./intelligenceRouteData.module.scss";
import tableStyles from "./intelligenceRouteTable.module.scss";

import VehicleReportTable from "../../VehcleReportTable/VehicleReportTable";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import CookieService from "../../../shared/services/cookiesService";
import configuration from "./../../../config.json";

const ROWS_ON_PAGE = 30;

class IntelligenceRouteData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActiveRow: false,
      vehicleReport: null,
    };

    this.getPositions = this.getPositions.bind(this);
    this.setCurrentRow = this.setCurrentRow.bind(this);
    this.isDatesUnequal = this.isDatesUnequal.bind(this);
    this.handleClickRow = this.handleClickRow.bind(this);
  }

  componentDidMount() {
    const {
      timerangeIntelligenceState,
      positionsDataState,
      onSetPositionsTableData,
      positionsPage,
      positionsTableData,
      currentPointDate,
      currentPositionDate,
      positionsTablePageData,
      positionsCount,
      onGetReportsList,
    } = this.props;

    const { vehicleReport } = this.state;

    if (vehicleReport === null) {
      onGetReportsList();
    }

    if (timerangeIntelligenceState === states.REQUEST && positionsDataState !== states.REQUEST) {
      this.getPositions();
    }

    if (timerangeIntelligenceState === states.READY && positionsDataState !== states.READY) {
      this.getPositions();
    }

    if (timerangeIntelligenceState === states.FAILURE && positionsDataState !== states.READY) {
      this.getPositions();
    }

    if (positionsCount > 0 && Object.entries(positionsTablePageData).length === 0) {
      onSetPositionsTableData(getRouteTableData(positionsPage, ROWS_ON_PAGE, positionsTableData, tableStyles));
    }

    if (positionsCount > 0 && !!currentPointDate && this.isDatesUnequal(currentPointDate, currentPositionDate)) {
      this.setCurrentRow();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      timerangeIntelligenceState,
      positionsDataState,
      onSetTimeRangeIntelligenceReady,
      onSetTimeRangeIntelligenceFailure,
      onSetPositionsTableData,
      positionsPage,
      positionsTableData,
      currentPositionDate,
      currentPointDate,
      positionsCount,
      reportsListDataState,
      reportsListData,
      onGetPositions,
      carId,
      startDate,
      endDate,
    } = this.props;

    const { isActiveRow } = this.state;

    if (prevProps.reportsListDataState === states.REQUEST && reportsListDataState === states.READY) {

      const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
      const vehicleReports = !!localStorage.getItem(configuration.vehicleReports)
        ? JSON.parse(localStorage.getItem(configuration.vehicleReports))
        : [];

      const customVehicleReport = vehicleReports.filter((x) => {
        return x.email === authData.email;
      })[0];

      const vehicleReport = reportsListData.filter((item) => {
        if (customVehicleReport !== undefined && customVehicleReport.id !== null) {
          if (item.id === customVehicleReport.id) {
            return true;
          }
        }

        return item.patternReport !== undefined && item.patternReport !== null && item.buildType === 0;
      })[0];

      this.setState({ vehicleReport });

      if (positionsDataState !== states.READY) {
        onGetPositions(
          {
            carId,
            startDate,
            endDate,
          },
          vehicleReport
        );
      }
    }

    if (timerangeIntelligenceState === states.REQUEST && prevProps.timerangeIntelligenceState !== states.REQUEST) {
      this.getPositions();
    }

    if (positionsDataState === states.READY && prevProps.positionsDataState === states.REQUEST && positionsCount > 0) {
      onSetPositionsTableData(getRouteTableData(positionsPage, ROWS_ON_PAGE, positionsTableData, tableStyles));

      if (this.isDatesUnequal(currentPointDate, currentPositionDate)) {
        this.setCurrentRow();
      }

      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceReady();
      }
    }

    if (positionsDataState === states.FAILURE && prevProps.positionsDataState === states.REQUEST) {
      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceFailure();
      }
    }

    if (positionsDataState === states.READY && prevProps.positionsDataState === states.REQUEST && positionsCount === 0) {
      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceFailure();
      }
    }

    if (positionsPage !== prevProps.positionsPage && positionsDataState === states.READY) {
      onSetPositionsTableData(getRouteTableData(positionsPage, ROWS_ON_PAGE, positionsTableData, tableStyles));

      if (isActiveRow) {
        this.setState({ isActiveRow: false });
      }
    }

    if (this.isDatesUnequal(currentPositionDate, prevProps.currentPositionDate) && positionsDataState === states.READY) {
      onSetPositionsTableData(getRouteTableData(positionsPage, ROWS_ON_PAGE, positionsTableData, tableStyles));

      if (!isActiveRow) {
        this.setState({ isActiveRow: false });
      }
    }
  }

  getPositions() {
    const { carId, startDate, endDate, onGetPositions } = this.props;
    if (this.state.vehicleReport != null) {
      onGetPositions(
        {
          carId,
          startDate,
          endDate,
        },
        this.state.vehicleReport
      );
    }
  }

  setCurrentRow() {
    const { positionsTableData, currentPointDate, onSetPositionsData, onSetPositionsPage, onSetCurrentPositionDate } = this.props;

    const currentRow = positionsTableData.find((item) => {
      const currentDate = getDates.getNullSecMsecTimeDateUtcNumber(currentPointDate);
      const startDate = getDates.getNullSecMsecTimeDateUtcNumber(item.date);
      const finishDate = getDates.getNullSecMsecTimeDateUtcNumber(item.finishDate);

      if (!!finishDate) {
        if (currentDate <= startDate) {
          return currentDate <= startDate && currentDate <= finishDate;
        } else {
          return currentDate >= startDate && currentDate <= finishDate;
        }
      } else {
        return currentDate === startDate;
      }
    });

    const lastRow = positionsTableData[positionsTableData.length - 1];
    const rowId = !!currentRow ? currentRow.id : lastRow.id;
    const rowNum = rowId + 1;
    const currentPage = Math.ceil(rowNum / ROWS_ON_PAGE);
    const updatedRoute = positionsTableData.map((item) => Object.assign({}, item));

    updatedRoute.forEach((item) => {
      item.isActive = !!currentRow ? item.index === currentRow.index : item.index === lastRow.index;
    });

    onSetPositionsPage(currentPage);
    onSetPositionsData(updatedRoute);
    onSetCurrentPositionDate(currentPointDate);
  }

  isDatesUnequal(firstDate, secondDate) {
    const firstDateUtc = !!firstDate ? getDates.getNullSecMsecTimeDateUtcNumber(firstDate) : null;
    const secondDateUtc = !!secondDate ? getDates.getNullSecMsecTimeDateUtcNumber(secondDate) : null;

    return firstDateUtc !== secondDateUtc;
  }

  handleClickRow(date, doubleClick = false) {
    const {
      onSetCurrentPoint,
      mapPoints,
      onSetMessagesSelectDateDataState,
      onChangeIntelligenceType,
      onSetZoom,
      onSetMapCenter,
    } = this.props;

    const index = mapPoints.findLastIndex((point) => {
      return new Date(point.date) <= new Date(date);
    });

    onSetMapCenter({ lat: mapPoints[index].location[0], lng: mapPoints[index].location[1] });
    onSetCurrentPoint(mapPoints[index].index, date);
    onSetMessagesSelectDateDataState(date);

    if (doubleClick) {
      onChangeIntelligenceType(intelligenceTypes.messages.value);
    }
  }

  render() {
    const { positionsDataState, positionsTableData, routeDataState, onSetRouteDataState, fullScreen } = this.props;

    return (
      <div className={styles.intelligenceRouteData}>
        {positionsDataState === states.READY && positionsTableData.days.length > 0 ? (
          <VehicleReportTable
            tableData={positionsTableData}
            dataState={routeDataState}
            onSetDataState={onSetRouteDataState}
            handleClickRow={this.handleClickRow}
            height={fullScreen ? 450 : 300}
          />
        ) : positionsDataState === states.READY && positionsTableData.days.length === 0 ? (
          <Notification type="warning">
            <p>{messages.noData}</p>
          </Notification>
        ) : positionsDataState === states.FAILURE ? (
          <Notification type="error">
            <p>{messages.error}</p>
          </Notification>
        ) : positionsDataState === states.REQUEST ? (
          <div className={styles.container_preloader}>
            <Preloader />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withMapControl(
  withIntelligenceControl(
    withTimeRangeIntelligenceType(
      withIntelligenceTimeRangePlayer(withPositions(withMapPositions(withReportsList(withTimerangeIntelligence(IntelligenceRouteData)))))
    )
  )
);
